import { render, staticRenderFns } from "./InternalArticlesPending.vue?vue&type=template&id=447ec570&scoped=true"
import script from "./InternalArticlesPending.vue?vue&type=script&lang=js"
export * from "./InternalArticlesPending.vue?vue&type=script&lang=js"
import style0 from "./InternalArticlesPending.vue?vue&type=style&index=0&id=447ec570&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447ec570",
  null
  
)

export default component.exports